import { all, takeLatest } from 'redux-saga/effects'
import store from '../../store'
import { actions } from './ShipOrders.slice'
import { paginate } from './ShipOrders.thunk'

function paginateShipOrders () {
  store.dispatch(paginate() as any)
}

export default function * effects () {
  yield all([
    takeLatest(actions.replaceLimit, paginateShipOrders),
    takeLatest(actions.replacePage, paginateShipOrders),
    takeLatest(actions.replaceSearch, paginateShipOrders)
  ])
}
